<template>
  <span :class="['p2p-net', platform, { lg: large }]" :title="label" role="img" :aria-label="label">{{ letter }}</span>
</template>

<script>
const LETTERS = { x: 'X', linkedin: 'in', bluesky: 'B', instagram: 'IG', facebook: 'f', threads: '@', pinterest: 'P', tiktok: 'T', youtube: '▶' };
const LABELS = { x: 'X', linkedin: 'LinkedIn', bluesky: 'Bluesky', instagram: 'Instagram', facebook: 'Facebook', threads: 'Threads',
  pinterest: 'Pinterest', tiktok: 'TikTok', youtube: 'YouTube Shorts' };
export { LABELS };
export default {
  name: 'NetBadge',
  props: { platform: { type: String, required: true }, large: { type: Boolean, default: false } },
  computed: {
    letter() { return LETTERS[this.platform] || this.platform.charAt(0).toUpperCase(); },
    label() { return LABELS[this.platform] || this.platform; }
  }
};
</script>
